import { ReferenceInput, SelectInput } from "react-admin";

import { specialistRequests } from "api/specialistApi";
import EmployeeInput from "server/components/Fields/EmployeeInput";
import CustomDateTimeInput from "server/components/Fields/CustomDateTimeInput";

const campaignApplicationFilters = [
  <EmployeeInput
    source="employeeId"
    alwaysOn
  />,
  <CustomDateTimeInput
    source="createdFrom"
    label="Създадена от"
    alwaysOn
  />,
  <CustomDateTimeInput
    source="createdTo"
    label="Създадена до"
    alwaysOn
  />,

  <ReferenceInput
    source="statusId"
    reference={specialistRequests.getCampaignApplicationStatusesSelect()}
    alwaysOn
  >
    <SelectInput
      label="Статус"
      optionText="nameBg"
    />
  </ReferenceInput>,
];
export default campaignApplicationFilters;
